import {
  CategoryIcon,
  IconStarDefault,
  isCategorySlug,
} from '@mc/design-system'
import Link from 'components/Link'
import { ALL_CLASSES } from 'libs/utils'
import type { Category } from '../types'
import styles from './CategoryNavIconItem.module.scss'

type CategoryNavIconItemProps = {
  category: Category
  slug?: string
  pathCategory: (slug: string) => string
  onNavClick?: (category: Category) => void
}

export const CategoryNavIconItem = ({
  category,
  slug,
  pathCategory,
  onNavClick,
}: CategoryNavIconItemProps) => (
  <Link
    passHref
    tabIndex={0}
    href={pathCategory(category.slug)}
    onClick={() => onNavClick?.(category)}
  >
    <CategoryNavContent
      selection={category}
      isSelected={category.slug === slug}
      onSelect={pathCategory}
    />
  </Link>
)

interface CategoryNavIconProps {
  selection: Category
  isSelected: boolean
  onSelect: (slug: string, id: number) => void
}

const CategoryNavContent = ({
  selection,
  isSelected,
}: CategoryNavIconProps) => {
  const getIcon = () => {
    if (selection.slug === ALL_CLASSES) {
      return (
        <>
          <IconStarDefault size={3} className='d-md-none' />
          <IconStarDefault size={4} className='d-none d-md-block' />
        </>
      )
    }

    if (isCategorySlug(selection.slug)) {
      return (
        <>
          <CategoryIcon slug={selection.slug} size={3} className='d-md-none' />
          <CategoryIcon
            slug={selection.slug}
            size={4}
            className='d-none d-md-block'
          />
        </>
      )
    }

    return <></>
  }

  return (
    <div
      className={`mc-pt-2 mc-pb-4 mc-py-md-6 mc-px-1 ${styles.filterButton} ${
        isSelected ? styles.filterButtonActive : ''
      }`}
    >
      <div className='d-flex flex-column align-items-center justify-content-between mc-h-100'>
        <span
          className={`${styles.icon} ${isSelected ? styles.iconActive : ''}`}
        >
          {getIcon()}
        </span>
        <div
          className={`mc-mt-1 mc-mt-md-3 mc-h-100 d-flex align-items-center ${styles.text}`}
        >
          <span className='mc-text--bold mc-text-x-small mc-text--center'>
            {selection.name}
          </span>
        </div>
      </div>
    </div>
  )
}
